"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { registerEditorNavigationGuard } from "@/lib/editor/navigation-guard";
export function useEditorNavigation(t0, t1) {
  const $ = _c(11);
  const {
    beforeNavigate,
    saveDraft,
    hasUnsavedChanges
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const router = useRouter();
  let t2;
  let t3;
  if ($[0] !== beforeNavigate || $[1] !== enabled) {
    t2 = () => enabled ? registerEditorNavigationGuard(beforeNavigate) : undefined;
    t3 = [beforeNavigate, enabled];
    $[0] = beforeNavigate;
    $[1] = enabled;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== beforeNavigate || $[5] !== enabled || $[6] !== hasUnsavedChanges || $[7] !== router || $[8] !== saveDraft) {
    t4 = () => {
      if (!enabled) {
        return;
      }
      const onClick = event => {
        if (!hasUnsavedChanges() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        const anchor = event.target instanceof Element ? event.target.closest("a[href]") : null;
        if (!anchor || anchor.target || anchor.hasAttribute("download")) {
          return;
        }
        const destination = new URL(anchor.href, location.href);
        if (!/^https?:$/.test(destination.protocol)) {
          return;
        }
        if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        beforeNavigate().then(saved => {
          if (!saved) {
            return;
          }
          if (destination.origin === location.origin) {
            router.push(destination.pathname + destination.search + destination.hash);
          } else {
            location.assign(destination.href);
          }
        });
      };
      const onUnload = event_0 => {
        if (!hasUnsavedChanges()) {
          return;
        }
        event_0.preventDefault();
        event_0.returnValue = "";
      };
      const onHidden = () => {
        if (document.visibilityState === "hidden") {
          saveDraft();
        }
      };
      document.addEventListener("click", onClick, true);
      document.addEventListener("visibilitychange", onHidden);
      window.addEventListener("beforeunload", onUnload);
      return () => {
        document.removeEventListener("click", onClick, true);
        document.removeEventListener("visibilitychange", onHidden);
        window.removeEventListener("beforeunload", onUnload);
        saveDraft();
      };
    };
    t5 = [beforeNavigate, hasUnsavedChanges, router, saveDraft, enabled];
    $[4] = beforeNavigate;
    $[5] = enabled;
    $[6] = hasUnsavedChanges;
    $[7] = router;
    $[8] = saveDraft;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
}